import { Component } from "@angular/core";
import { ConfigService } from "../../services/config.service";
import { NavController, NavParams, ViewController } from "ionic-angular";

@Component({
  selector: "page-termsofuse",
  templateUrl: "termsofuse.html"
})
export class TermsofusePage {
  idioma: string;
  constructor(
    private configService: ConfigService,
    public viewCtrl: ViewController
  ) {
    this.idioma = this.configService.getIdiom();
  }

  ionViewDidLoad() {
    console.log("ionViewDidLoad TermsofusePage");
  }
  ionViewWillEnter() {}
}



// WEBPACK FOOTER //
// ./src/pages/termsofuse/termsofuse.ts